import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { copyTextToClipboard, isReady } from "../utils/helpers";
import { getSource } from "../utils/get-source";

const SourceModal = props => {
  const {
    buttonLabel,
    className,
    signature,
    template,
    social,
    showAlert
  } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  return (
    <>
      <Button
        className="flex-grow-1"
        onClick={toggle}
        disabled={isReady(signature)}
      >
        {buttonLabel}
      </Button>
      <Modal isOpen={modal} toggle={toggle} className={className} size="lg">
        <ModalHeader toggle={toggle}>Tu firma para tu e-mail</ModalHeader>
        <ModalBody className="py-0">
          <FormGroup className="m-0">
            <Label for="source">
              Copiar el código HTML
            </Label>
            <Input
              type="textarea"
              className="p-2"
              name="source"
              defaultValue={getSource(signature, template)}
              rows="6"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button onClick={toggle}>Cancelar</Button>
          <Button
            color="primary"
            onClick={() => {
              copyTextToClipboard(
                getSource(signature, template, social),
                showAlert
              );
              toggle();
            }}
          >
            Copiar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SourceModal;
